module.exports = __webpack_public_path__ + "img/empty.1763f6d9.png";